import { BaseApi } from '../base-api';

export class ClientSsoApi extends BaseApi {
  protected readonly prefix = 'clients';
  protected readonly version = '2';
  

  deleteConsent = (clientId: string, coverage = 'organization') => this.delete(`${clientId}/consent`, { coverage });
}
